// src/data/resources.js
// ─── お役立ち資料・情報データ ─────────────────────────────────────
// type: "svg" | "pdf" | "image" | "link"
// category: "技術資料" | "業界情報" | "社内資料" | "規格・基準"

const resourcesData = [
  {
    id: 1,
    title: "シリコンウェーハができるまで",
    subtitle: "単結晶引上工程・ウェーハ加工工程・特殊加工工程 技術解説",
    category: "技術資料",
    type: "svg",
    file: "/images/silicon_wafer_process_zenkyo.svg",
    date: "2026-08",
    description:
      "シリコンウェーハが砂（SiO₂）から製品になるまでの全工程を図解。単結晶引上・スライス・研磨・特殊加工の各ステップを詳細なイラストと解説で紹介します。",
    tags: ["半導体", "ウェーハ", "製造工程", "シリコン"],
  },
  // 追加資料はここに追記
];

export default resourcesData;
